<template>
  <v-container fluid id="miniContainers" class="pa-0 pa-sm-3">
    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
      <v-btn text @click="snack = false">Close</v-btn>
    </v-snackbar>
    <v-dialog v-model="historyDialog" width="800">
      <v-card v-if="currentMini">
        <v-card-title class="headline">
          Mini Inventory History
        </v-card-title>
        <v-card-text>
          <div class="title">{{ currentMini.jobSite.address }}</div>
          <v-container grid-list-xl class="pa-0">
            <v-row>
              <v-col cols="12" xs="12">
                <v-simple-table dense>
                  <thead>
                    <tr>
                      <th class="text-left">
                        New Qty
                      </th>
                      <th class="text-left">
                        Old Qty
                      </th>
                      <th class="text-left">
                        Update Type
                      </th>
                      <th class="text-left">
                        Updated By
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(h, ix) in currentMini.history" :key="ix">
                      <td>{{ h.newAmount }}</td>
                      <td>{{ h.originalAmount }}</td>
                      <td>
                        <span v-if="h.updateType === 'truckRequest'">
                          <a
                            :href="
                              `/truck-requests/manage/orders/${h.truckRequest}`
                            "
                            target="_blank"
                            >Request</a
                          >
                        </span>
                        <span v-else>Adjustment</span>
                      </td>
                      <td>
                        {{ h.updateBy.firstName }} {{ h.updateBy.lastName }}
                        <div class="caption">
                          on
                          {{ h.createDate.toDate() | moment("MMM Do YYYY") }}
                          <p class="mt-1 mb-0 pb-0 grey--text text--darken-2">
                            {{ h.note }}
                          </p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
                <!-- createDate: (...)
                newAmount: (...)
                note: (...)
                originalAmount: (...)
                updateBy: (...)
                updateType: (...) -->
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="historyDialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="adjustmentDialog" width="500">
      <v-card v-if="currentMini">
        <v-card-title class="headline">
          Create Mini Inventory Adjustment
        </v-card-title>
        <v-card-text>
          <v-container grid-list-xl class="pa-0">
            <v-row>
              <v-col cols="12" xs="12">
                <h3>
                  <p
                    class="ma-0 pa-0 body-2 font-weight-bold"
                    style="line-height:1.4em"
                  >
                    {{ currentMini.jobSite.street }}
                    <span class="font-weight-regular">
                      {{ currentMini.jobSite.street2 }}</span
                    >
                  </p>

                  <p
                    class="caption grey--text ma-0 pa-0"
                    style="line-height:1.4em"
                  >
                    {{ currentMini.jobSite.city }}
                    {{ currentMini.jobSite.postalCode }}
                  </p>

                  <p
                    class="caption text--darken-4 ma-0 pa-0"
                    style="line-height:1.4em"
                  >
                    Job ID:
                    <strong>{{ currentMini.jobSite.jobId }} </strong>
                    <span
                      v-if="currentMini.jobSite.department"
                      style="text-transform:uppercase"
                    >
                      {{ currentMini.jobSite.department.join(", ") }}</span
                    >
                  </p>
                </h3>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  outlined
                  dense
                  disabled
                  type="number"
                  label="Inventory Count"
                  v-model="currentMini.count"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  outlined
                  dense
                  type="number"
                  label="New Count"
                  v-model.number="newCount"
                  :rules="[(v) => !!v || 'required']"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12">
                <p class>* Describe why this adjustment has to be made.</p>
                <v-textarea
                  outlined
                  dense
                  type="text"
                  label="Adjustment Note"
                  v-model="adjustmentNote"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="adjustmentDialog = false">
            cancel
          </v-btn>
          <v-btn
            color="primary"
            @click="createAdjustment"
            class="ml-4"
            :disabled="submittingAdjustment"
          >
            Create Adjustment
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row wrap class="justify-left">
      <v-col cols="12" xs="12" class="headline pb-0"
        >Mini Containers
        <span class="caption ml-1">Total {{ totalCount }}</span></v-col
      >
      <v-col cols="12" xs="12" sm="12" md="8">
        <v-card>
          <v-tabs v-model="activeTab">
            <v-tab>Open Jobs</v-tab>
            <v-tab>Closed Jobs</v-tab>
          </v-tabs>
          <v-divider></v-divider>
          <v-data-table
            :items="filteredMiniContainers"
            :loading="loadingMiniContainers"
            loading-text="Loading....please wait."
            :headers="headers"
            :items-per-page="40"
            sort-by="count"
            sort-desc
          >
            <template v-slot:top>
              <v-toolbar flat color="white" class="pt-1">
                <v-text-field
                  outlined
                  dense
                  hide-details
                  v-model="search"
                  append-icon="search"
                  label="Filter by address or job ID"
                  clearable
                ></v-text-field>
                <v-switch
                  class="ml-4 mt-0 pt-0"
                  hide-details
                  v-model="showEmpty"
                  label="Show empty (0)"
                ></v-switch>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  class="ml-3"
                  :disabled="loadingMiniContainers"
                  @click="downloadReport"
                >
                  <v-icon left>get_app</v-icon>
                  Report
                </v-btn>
              </v-toolbar>
            </template>
            <template v-slot:item.id="{ item }">
              {{ item.jobSite.street }}
              <span class="caption">({{ item.jobSite.jobId }})</span>
              <span class="red--text" v-if="item.jobSite.status == 'closed'">
                * CLOSED
              </span>
            </template>
            <template v-slot:item.jobSite="{ item }">
              <v-btn
                color="primary"
                small
                outlined
                text
                @click.stop="adjustMiniCount(item)"
                >Adjustment</v-btn
              >
              <v-btn
                :disabled="!item.history"
                color="primary"
                small
                outlined
                text
                class="ml-2"
                @click="viewHistory(item)"
                >History</v-btn
              >
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import fb from "@/main";
import { mapState } from "vuex";
import moment from "moment";
import { chunk } from "lodash";
export default {
  data() {
    return {
      activeTab: 0,
      search: "",
      showEmpty: false,
      adjustmentDialog: false,
      historyDialog: false,
      submittingAdjustment: false,
      miniContainers: [],
      totalCount: 0,
      newCount: null,
      loadingMiniContainers: true,
      currentMini: null,
      adjustmentNote: "",
      headers: [
        { text: "Job", value: "id" },
        { text: "Count", value: "count", align: "right" },
        { text: "", value: "jobSite", align: "right" },
      ],
      snack: false,
      snackColor: "",
      snackText: "",
    };
  },
  computed: {
    filteredMiniContainers() {
      let filtered;
      if (this.activeTab === 0) {
        // Open jobs
        filtered = this.miniContainers.filter(
          (m) => m.jobSite && m.jobSite.status !== "closed"
        );
      } else {
        // Closed jobs
        filtered = this.miniContainers.filter(
          (m) => m.jobSite && m.jobSite.status === "closed"
        );
      }
      // Apply search filter
      if (this.search) {
        const searchLower = this.search.toLowerCase();
        filtered = filtered.filter((m) => {
          const street = (m.jobSite.street || "").toLowerCase();
          const address = (m.jobSite.address || "").toLowerCase();
          const jobId = (m.jobSite.jobId || "").toLowerCase();
          return (
            street.includes(searchLower) ||
            address.includes(searchLower) ||
            jobId.includes(searchLower)
          );
        });
      }
      // Hide empty (0-count) locations by default to cut the noise. Reveal
      // them when the user flips the toggle, OR when a search is active so
      // history lookups by address/job ID still surface zeroed-out jobs.
      // Note: a non-zero count (incl. a negative data anomaly) always shows.
      if (!this.showEmpty && !this.search) {
        filtered = filtered.filter((m) => m.count !== 0);
      }
      return filtered;
    },
    ...mapState(["jobSites", "user"]),
  },
  async created() {
    try {
      // A miniContainers doc id is its job site id, so fetch just those job
      // sites (cached across snapshots) instead of every job site (#108).
      const jobs = {};
      this.unsubscribeMiniContainers = await fb.db
        .collection("miniContainers")
        .onSnapshot(async (querySnapshot) => {
          try {
            const missing = querySnapshot.docs
              .map((doc) => doc.id)
              .filter((id) => !(id in jobs));
            const results = await Promise.all(
              chunk(missing, 10).map((ids) =>
                fb.db
                  .collection("jobSites")
                  .where(fb.firebase.firestore.FieldPath.documentId(), "in", ids)
                  .get()
              )
            );
            missing.forEach((id) => (jobs[id] = null));
            results.forEach((res) =>
              res.forEach((j) => (jobs[j.id] = { id: j.id, ...j.data() }))
            );
            var miniContainers = [];
            querySnapshot.forEach(function(doc) {
              miniContainers.push({
                id: doc.id,
                ...doc.data(),
                jobSite: jobs[doc.id],
              });
            });
            this.miniContainers = miniContainers;
            this.totalCount = miniContainers
              .map((m) => m.count)
              .reduce((a, b) => a + b, 0);
          } catch (error) {
            alert("Error loading mini containers.");
            console.log(error);
          }
          this.loadingMiniContainers = false;
        });
    } catch (error) {
      alert("Error loading mini containers.");
      console.log(error);
      this.loadingMiniContainers = false;
    }
  },
  beforeDestroy() {
    this.unsubscribeMiniContainers();
  },
  methods: {
    adjustMiniCount(item) {
      this.adjustmentDialog = true;
      this.newCount = item.count;
      this.currentMini = item;
    },
    async createAdjustment() {
      try {
        if (!this.adjustmentNote) {
          alert("Adjustment note is required.");
          return;
        }
        this.submittingAdjustment = true;
        const payload = {};
        const id = `history.${moment().unix()}`;
        payload[id] = {
          originalAmount: this.currentMini.count,
          newAmount: this.newCount || 0,
          note: this.adjustmentNote,
          updateBy: this.user,
          createDate: fb.timestamp,
          updateType: "adjustment",
        };
        payload.count = this.newCount;
        await fb.db
          .collection("miniContainers")
          .doc(this.currentMini.id)
          .update(payload);
        this.adjustmentDialog = false;
        this.snack = true;
        this.snackColor = "success";
        this.snackText = "Successfully submitted adjustment";
        this.resetAdjustment();
        this.submittingAdjustment = false;
      } catch (error) {
        this.adjustmentDialog = false;
        this.snack = true;
        this.snackColor = "error";
        this.snackText = "Error submitting adjustment";
        this.resetAdjustment();
        this.submittingAdjustment = false;
      }
    },
    resetAdjustment() {
      this.newCount = null;
      this.adjustmentNote = "";
    },
    viewHistory(item) {
      this.currentMini = item;
      this.historyDialog = true;
    },
    downloadReport() {
      // Every location currently holding minis (count > 0), regardless of
      // open/closed status and even if the underlying job was deleted.
      const rows = this.miniContainers
        .filter((m) => m.count > 0)
        .sort((a, b) => b.count - a.count);

      if (!rows.length) {
        this.snack = true;
        this.snackColor = "error";
        this.snackText = "No locations currently have minis on site.";
        return;
      }

      const headers = [
        "Job ID",
        "Location",
        "City",
        "Postal Code",
        "Department",
        "Job Status",
        "Mini Count",
      ];

      const dataRows = rows.map((m) => {
        const job = m.jobSite;
        const location = job
          ? [job.street, job.street2].filter(Boolean).join(" ")
          : "Unknown location (job not found)";
        const department =
          job && job.department ? job.department.join(", ") : "";
        return [
          job ? job.jobId || "" : "",
          location,
          job ? job.city || "" : "",
          job ? job.postalCode || "" : "",
          department,
          job ? job.status || "open" : "",
          m.count,
        ];
      });

      // Escape any field containing commas, quotes, or newlines.
      const escape = (field) => {
        const str = String(field == null ? "" : field);
        if (str.includes(",") || str.includes('"') || str.includes("\n")) {
          return `"${str.replace(/"/g, '""')}"`;
        }
        return str;
      };

      const csvContent = [
        headers.join(","),
        ...dataRows.map((row) => row.map(escape).join(",")),
      ].join("\n");

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute(
        "download",
        `mini_containers_on_site_${moment().format("YYYY-MM-DD")}.csv`
      );
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      this.snack = true;
      this.snackColor = "success";
      this.snackText = `Downloaded ${rows.length} location(s) with minis on site.`;
    },
  },
};
</script>
